import { createReducer, on } from '@ngrx/store'
import { CommonDomainComponentsActions } from './action-types'
import { AttachmentUploadedType } from '../../../../../api/backend'

export const initState: ICommonDomainComponentsState = {
    attachmentTypeScanData: {
        attachmentId: null,
        uploadedType: null,
        checkedAll: false,
        checkedIds: []
    }
}

export const commonDomainComponentsReducer = createReducer(
    initState,
    on(CommonDomainComponentsActions.resetAttachmentTypeScanData, (state) => {
        return {...state, attachmentTypeScanData: {...initState.attachmentTypeScanData}}
    }),
    on(CommonDomainComponentsActions.setAttachmentTypeScanDataProperty, (state, props) => {
        const copy = {...state.attachmentTypeScanData}

        copy[props.property] = props.value

        return {...state, attachmentTypeScanData: copy}
    })
)

export interface ICommonDomainComponentsState {
    attachmentTypeScanData: IAttachmentTypeScanData;
}

export interface IAttachmentTypeScanData {
    attachmentId: any;
    uploadedType: AttachmentUploadedType;
    checkedAll: boolean;
    checkedIds: number[];
}